import type {
  AgeVerificationScriptConfigItem,
  ColorVariant,
  DynamicLink,
  FirebaseSdkCredentials,
  Language,
  ProductSpecification,
} from "../../config";

export const parseConfigurationString = (config: string): Record<string, string | DynamicLink[]> => {
  if (config) {
    try {
      return JSON.parse(config);
    } catch {
      return {};
    }
  }

  return {};
};

type CurrentConfiguration = Record<
  string,
  | string
  | DynamicLink[]
  | string[]
  | AgeVerificationScriptConfigItem[]
  | boolean
  | Language[]
  | ProductSpecification
  | FirebaseSdkCredentials
  | ColorVariant[]
>;

let lastKnownConfiguration: CurrentConfiguration = {};

export function getCurrentConfiguration(): CurrentConfiguration {
  const configurationMeta = window.document.querySelector<HTMLMetaElement>(
    `meta[property="configuration"], meta[name="configuration"]`
  );

  if (!configurationMeta?.content) {
    return lastKnownConfiguration;
  }

  lastKnownConfiguration = parseConfigurationString(configurationMeta.content);

  return lastKnownConfiguration;
}

export const getUrlWithHash = (hash = "", url = ""): string => {
  return `${url}${hash}`;
};
